import * as Sentry from '@sentry/browser';
import { useCookies } from 'react-cookie';

const backendBasePath = process.env.NEXT_PUBLIC_DEV_BACKEND_URL;

type ActivityLogParams = {
  event_name: string;
  path?: string;
  properties?: Record<string, unknown>;
  notify?: boolean;
};

export const useCompanyActivityLog = () => {
  const [cookies] = useCookies(['expiry', 'access-token', 'client', 'uid', 'user-type']);

  const sendActivityLog = async (params: ActivityLogParams): Promise<{ ok: boolean }> => {
    const url = `${backendBasePath}/company/activity_logs`;

    try {
      const response = await fetch(url, {
        method: 'POST',
        mode: 'cors',
        headers: {
          uid: cookies['uid'],
          client: cookies['client'],
          'access-token': cookies['access-token'],
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          activity_log: {
            ...params,
            occurred_at: new Date().toISOString(),
          },
        }),
      });
      return { ok: response.ok };
    } catch (error) {
      Sentry.captureException(error);
      console.error('Error:', error);
      return { ok: false };
    }
  };

  return { sendActivityLog };
};
